<div [formGroup]="parentFormGroup" class="form-container">
  <mat-form-field appearance="outline" class="form-date">
    <mat-label i18n>Booking window opens</mat-label>
    <input matInput [matDatepicker]="bookingWindowOpen" id="booking-window-open-date" formControlName="openDate">
    <mat-datepicker-toggle matSuffix [for]="bookingWindowOpen"></mat-datepicker-toggle>
    <mat-datepicker #bookingWindowOpen></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline" class="form-hour">
    <mat-label i18n>Hour</mat-label>
    <mat-select id="booking-window-open-hour" formControlName="openHour">
      @for (option of hourNames; track option) {
        <mat-option [value]="option.id">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="form-minute">
    <mat-label i18n>Minute</mat-label>
    <mat-select id="booking-window-open-minute" formControlName="openMinute">
      @for (option of minuteNames; track option) {
        <mat-option [value]="option.id">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
